import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { deleteMeetingNotesTemplate } from "../api/meetingNotesTemplates";

export const useDeleteMeetingNotesTemplate = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate: deleteMeetingNotesTemplateMutate, isLoading } = useMutation(
    {
      mutationFn: (id) => deleteMeetingNotesTemplate(id),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["meeting-notes-templates"],
        });
        queryClient.invalidateQueries({ queryKey: ["users"] });
        toast.success("Template deleted");
        onSuccess?.();
      },
      onError: () => {
        toast.error("There was a problem deleting the template. Please try again.");
      },
    },
  );

  return { deleteMeetingNotesTemplateMutate, isLoading };
};
